import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import VideoPlayer from './CustomVideoPlayer'; // Ensure this path is correct

const ProjectDetailsModal = ({
    title,
    screenshots,
    demoVideoSource,
    description,
    technologiesUsed,
    technologiesUsedNames,
    clientReviewImage,
    projectDemoText,
    downloadAPKLink,
}) => {
    // Responsive config for the main screenshots carousel
    const screenshotsResponsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
    };

    // A separate, more suitable responsive config for the tech logo carousel
    const techCarouselResponsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 8 },
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 4 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 3 }
    };

    // A more robust data structure combining technology images and names
    const technologies = technologiesUsed.map((img, index) => ({
        src: img,
        name: technologiesUsedNames[index]
    }));

    // Function to handle APK download
    const handleDownload = (downloadLink, fileName) => {
        const link = document.createElement('a');
        link.href = downloadLink;
        link.download = fileName || "Demo.apk"; // Use provided filename or a default
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Modal.Body className='detailsbody' style={{ overflowY: 'auto' }}>

            {/* Screenshots Section */}
            <h4 className="modal-section-header">Screenshots</h4>
            <Carousel responsive={screenshotsResponsive} infinite={true} speed={500} arrows={true}>
                {screenshots.map((img, index) => (
                    <div key={index} className="screenshot-item">
                        <img src={img} alt={`${title} screenshot ${index + 1}`} className="screenshot-img" />
                    </div>
                ))}
            </Carousel>

            {/* Optional Working Video Section */}
            {/* 
            <h4 className="modal-section-header">Working Video</h4>
            <div style={{ padding: '0 10px' }}>
                <VideoPlayer videoSource={demoVideoSource} />
            </div>
            */}

            {/* Description Section */}
            <h4 className="modal-section-header">Description</h4>
            <div className="modal-description">
                <p>{description}</p>
            </div>

            {/* Technologies Used Section */}
            <h4 className="modal-section-header">Technologies Used</h4>
            <Carousel
                responsive={techCarouselResponsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2000}
                arrows={false}
                className="tech-carousel"
            >
                {technologies.map((tech, index) => (
                    <div key={index} className="tech-item">
                        <div className="tech-icon-container">
                            <img src={tech.src} alt={tech.name} className="tech-icon" />
                        </div>
                        <h5>{tech.name}</h5>
                    </div>
                ))}
            </Carousel>

            {/* Optional Client Review Section */}
            {/*
            {clientReviewImage && (
                <>
                    <h4 className="modal-section-header">Client Review</h4>
                    <div className="client-review-container">
                        <img src={clientReviewImage} alt="Client Review" className="client-review-img" />
                    </div>
                </>
            )}
            */}

            {/* Optional Project Demo Download Section */}
            {/*
            {downloadAPKLink && (
                <>
                    <h4 className="modal-section-header">Project Demo</h4>
                    <div className="project-demo-container">
                        <p>{projectDemoText}</p>
                        <Button
                            onClick={() => handleDownload(downloadAPKLink, `${title} Demo.apk`)}
                            className="download-apk-button"
                        >
                            Download Apk
                        </Button>
                        <p className="demo-note">
                            Note: This Apk is not the production app and is just for demonstration purposes with the permission of the respective client.
                        </p>
                    </div>
                </>
            )}
            */}

        </Modal.Body>
    );
};

export default ProjectDetailsModal;
